import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {TransformInfo} from "#template/interface-descriptors"
import {transformMarker} from "#template/nodes/transform/marker"

export {
    isTransformLikeNode,
    isTransformLikeNodeClass,
    isTransformLike,
    transformLike,
    transformLikeMarker,
    transformLikeNode,
} from "#template/nodes/transform/marker"
export type {TransformLike, TransformLikeNode} from "#template/nodes/transform/marker"
export type {TransformValue} from "#template/value-types"

export const TransformFT = createFundamentalType({
    name: "Transform",
    marker: transformMarker,
    InfoClass: TransformInfo,
    icon: "far fa-expand-arrows-alt",
})

@registerFundamentalNode(TransformFT, "Likes")
export class TransformLikes extends TransformFT.Likes {}

@registerFundamentalNode(TransformFT, "Switch")
export class TransformSwitch extends TransformFT.Switch {}

@registerFundamentalNode(TransformFT, "Input")
export class TransformInput extends TransformFT.Input {}

@registerFundamentalNode(TransformFT, "Output")
export class TransformOutput extends TransformFT.Output {}

@registerFundamentalNode(TransformFT, "Export")
export class TransformExport extends TransformFT.Export {}
